import type { Column, Row, RowData } from '@tanstack/react-table';
import { z } from 'zod';

const selectValueSchema = z.string().nullable().optional();

const selectFilterSchema = z.string();

export type SelectFilterValue = z.infer<typeof selectFilterSchema>;

export function typedSetSelectColumnFilterValue<TData extends RowData>(
    column: Column<TData, unknown>,
    filterValue: SelectFilterValue
) {
    column.setFilterValue(filterValue);
}

export function selectFilter<TData extends RowData>(row: Row<TData>, columnId: string, filterValue: SelectFilterValue) {
    const filter = selectFilterSchema.parse(filterValue);
    const value = selectValueSchema.parse(row.getValue(columnId));

    if (value === null || value === undefined) {
        if (filter !== null && filter !== undefined) {
            return false;
        } else {
            return true;
        }
    } else if (filter === null || filter === undefined) {
        return true;
    }

    return value.trim().toLowerCase() === filter.trim().toLowerCase();
}
